import React, { useEffect, useState } from "react";
import axios from "../../utils/axiosConfig";
import '../styles/AdminContact.css';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

const AdminContact = () => {

  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedMsg, setSelectedMsg] = useState(null);

  const recordsPerPage = 10;

  useEffect(() => {

    const loadData = async () => {
      try {
        const res = await axios.get("/api/contact");
        setData(res.data);
      } catch (err) {
        console.error(err);
      }
    };
  
    loadData();
  
  }, []);


  const handleDelete = async (id) => {

    if (window.confirm("Delete this message?")) {

      try {

        await axios.delete(
          `/api/contact/${id}`);

        const res = await axios.get("/api/contact");

        setData(res.data);

      } catch (err) {
        console.error(err);
      }

    }

  };

  const filteredData = data.filter((item) => {

    const matchSearch =
      item.name.toLowerCase().includes(search.toLowerCase()) ||
      item.email.toLowerCase().includes(search.toLowerCase()) ||
      item.subject.toLowerCase().includes(search.toLowerCase());

    const matchDate = date
      // ? new Date(item.contactdate).toISOString().slice(0, 10) === date
      ? new Date(item.contactdate).toLocaleDateString("en-CA").slice(0, 10) === date
      : true;

    return matchSearch && matchDate;

  });

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  
/*==== DATE FORMAT ====*/
const formatDate = (date) => {

  if (!date) return "";
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
};

  // const today = new Date().toDateString();
  const today = new Date().toLocaleDateString("en-CA");

  const totalMessages = data.length;

  const todayMessages = data.filter(
    // (item) => new Date(item.contactdate).toDateString() === today
    (item) => new Date(item.contactdate).toLocaleDateString("en-CA") === today
  ).length;

  const exportExcel = () => {

    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Contacts");

    const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    const file = new Blob([buffer], { type: "application/octet-stream" });

    saveAs(file, "Filtered_ContactData.xlsx");

  };

  const chartData = data.reduce((acc, item) => {

    const d = new Date(item.contactdate).toLocaleDateString("en-IN");

    const found = acc.find((x) => x.date === d);

    if (found) {
      found.count += 1;
    } else {
      acc.push({ date: d, count: 1 });
    }

    return acc;

  }, []);

  return (

    <div className="admin-wrapper">

      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="admin-title">Contact Messages</h2>
        {/* <button onClick={logout} className="logout-btn">Logout</button> */}
      </div>

      <div className="dashboard">
        <div className="card">Total Contacts : {totalMessages}</div>
        <div className="card">Today Contacts : {todayMessages}</div>
      </div>

      <div className="d-flex gap-3 flex-wrap mb-3">

        <input
          type="text"
          placeholder="Search..."
          className="search-box"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <input
          type="date"
          className="search-box"
          onChange={(e) => setDate(e.target.value)}
        />

        <button className="export-btn" onClick={exportExcel}>
          Export Excel
        </button>

      </div>

      <div style={{ overflowX: "auto", marginBottom: "20px" }}>

        <BarChart width={600} height={300} data={chartData}>
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="count" />
        </BarChart>

      </div>

      <div className="table-responsive">
        <table className="tables admin-table">
          <thead>
            <tr>
              {/* <th>ID</th> */}
              <th>Name</th>
              <th>Email</th>
              <th>Subject</th>
              <th>Phone</th>
              <th>Message</th>
              <th>Date</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {currentRecords.length > 0 ? (
              currentRecords.map((item) => (
                <tr key={item.id}>
                  {/* <td>{item.id}</td> */}
                  <td>{item.name}</td>
                  <td>{item.email}</td>
                  <td>{item.subject}</td>
                  <td>{item.phone}</td>
                  <td>
                    <button onClick={() => setSelectedMsg(item.message)}>
                      View
                    </button>
                  </td>
                  <td>
                    {/* {new Date(item.contactdate).toLocaleString()} */}
                    {formatDate(item.contactdate)}
                  </td>
                  <td>
                    <button
                      className="delete-btn"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))

            ) : (
              <tr>
                <td colSpan="8" className="text-center">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="pagination">

        {Array.from({ length: totalPages }, (_, i) => (

          <button
            key={i}
            onClick={() => setCurrentPage(i + 1)}
            className={currentPage === i + 1 ? "active" : ""}
          >
            {i + 1}
          </button>

        ))}

      </div>

      {selectedMsg && (

        <div className="modal-overlay" onClick={() => setSelectedMsg(null)}>

          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <h4>Message</h4>
            <p>{selectedMsg}</p>
            <button onClick={() => setSelectedMsg(null)}>Close</button>
          </div>

        </div>

      )}

    </div>

  );

};

export default AdminContact;